module.exports = __webpack_public_path__ + "static/media/cms9.ac3d0efa.png";